module.exports = __webpack_public_path__ + "img/9791158883058.dc315675.jpg";